<template>
  <v-dialog
    v-model="closeUploadFileDialog"
    no-click-animation
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
    width="650"
    :transition="false"
  >
    <v-card>
      <v-card-title class="pl-5">
        {{ $t("modules.productCategories") }}
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-layout wrap>
            <v-flex
              mt-4
              xs12
            >
              <v-file-input
                v-model="file"
                accept="text/csv"
                :label="$t('modules.bulkPayoutsUploadFile')"
                :error-messages="FileError"
                @blur="$v.file.$touch()"
              />
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          outlined
          @click="closeUploadFileDialog = false"
        >
          {{ $t("modules.closeButton") }}
        </v-btn>
        <v-btn
          color="primary"
          :disabled="loading || $v.$invalid"
          :loading="loading"
          @click="save()"
        >
          {{ $t("modules.bulkPayoutsUploadButton") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BULK_PAYOUTS_UPLOAD_MUTATION from "@/graphql/mutations/modules/BulkPayoutsUpload.gql";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "UploadFileDialog",
  mixins: [validationMixin],
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    whitelabelUuid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      file: null,
    };
  },
  validations() {
    return {
      file: {
        required,
      },
    };
  },
  computed: {
    closeUploadFileDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("closeUploadFileDialog", val);
      },
    },
    FileError() {
      const errors = [];
      if (!this.$v.file.$dirty) return errors;
      !this.$v.file.required && errors.push(this.$t("profile.reqField"));
      return errors;
    },
  },
  methods: {
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.loading = true;
      const params = {
        whitelabel_uuid: this.whitelabelUuid,
        file: this.file,
      };
      this.$apollo
        .mutate({
          mutation: BULK_PAYOUTS_UPLOAD_MUTATION,
          variables: params,
        })
        .then((data) => {
          this.loading = false;
          this.closeUploadFileDialog = true;
          this.$store.commit(
            "app/setNotifier",
            data.data.moduleBulkPayoutsUpload.message
          );
        })
        .catch((error) => {
          this.errorHandler(error);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
